import Vue from 'vue';
import PerfectScrollbar from 'perfect-scrollbar';

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            if (!el.contains(event.target)) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});

Vue.directive('custom-scroll', {
    bind: function (el, binding, vnode) {
        if (!el.hasOwnProperty('perfectScrollbar') || !el.perfectScrollbar) {
            el.perfectScrollbar = new PerfectScrollbar(el, {
                minScrollbarLength: 40
            });
            setTimeout(function () {
                if (el.hasOwnProperty('perfectScrollbar')) {
                    el.perfectScrollbar.update();
                }
            }, 500);
        } else {
            el.perfectScrollbar.update();
        }
        el.addEventListener('transitionend', () => {
            if (el.hasOwnProperty('perfectScrollbar')) {
                el.perfectScrollbar.update();
            }
        });
    },
    unbind: function (el) {
        if (el.hasOwnProperty('perfectScrollbar')) {
            el.perfectScrollbar.destroy();
        }
    }
});
